<script>
import Ajax from "@vvg/forum/js/mixins/ajax";
import Scroll from "@vvg/forum/js/mixins/scroll.js";
import {Link} from "@inertiajs/vue3";
import Reactions from "@vvg/forum/vue/reaction/index.vue";

export default {
  name: "show",
  components: {Link, Reactions},
  mixins: [Ajax, Scroll],
  props: {
    topicId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      topic: null,
    }
  },
  mounted() {
    this.$nextTick(() => this.scrollToForum());
    this.getTopic();
  },
  methods: {
    getTopic() {
      this.Ajax(this.$page.props.forum_url + 'retrieve_topic/?topic_id=' + this.$props.topicId).then((response) => {
        this.topic = response.data;
      });
    }
  }
}
</script>

<template>
  <div class="container-xl py-4">
    <div v-if="topic">

      <nav class="topic-breadcrumb mb-3" aria-label="Navigatie">
        <Link :href="$page.props.forum_url" class="topic-breadcrumb__link">Forum</Link>
        <i class="fa fa-chevron-right topic-breadcrumb__sep"></i>
        <Link :href="$page.props.forum_url + topic.forum_id + '/onderwerpen/'" class="topic-breadcrumb__link">
          {{ topic.forum?.title ?? 'Onderwerpen' }}
        </Link>
        <i class="fa fa-chevron-right topic-breadcrumb__sep"></i>
        <span class="text-muted">{{ topic.title }}</span>
      </nav>

      <div class="topic-show-card__body">
        <div class="topic-show-meta">
          <div class="topic-show-meta__avatar">
            <img
              v-if="topic.user?.profile_picture_url"
              :src="topic.user.profile_picture_url"
              :alt="topic.user.username"
              class="topic-show-meta__avatar-img"
            />
            <span v-else>{{ (topic.user?.username ?? 'O').slice(0, 2).toUpperCase() }}</span>
          </div>
          <Link
            v-if="topic.user && $page.props.auth.user"
            :href="$page.props.forum_url + 'profiel/' + topic.user.id + '/'"
            class="topic-show-meta__user"
          >{{ topic.user.username }}</Link>
          <span v-else-if="topic.user" class="topic-show-meta__user">{{ topic.user.username }}</span>
          <span v-else class="topic-show-meta__user">Onbekend</span>
          <span class="topic-show-meta__sep">·</span>
          <span class="topic-show-meta__date">{{ topic.created_at_formatted }}</span>
        </div>

        <div class="topic-show-layout">
          <div class="topic-show-layout__main">
            <h1 class="topic-show-title">{{ topic.title }}</h1>
            <div class="topic-show-desc text-wrapper" v-html="topic.description"></div>
          </div>

          <div
              v-if="topic.images && topic.images.length"
              class="topic-show-layout__aside"
          >
            <a
	            data-fancybox
                v-for="image in topic.images"
                :key="image.id"
                :href="image.file_location"
                target="_blank"
                class="topic-show-images__item d-block zoom-wrap overflow-hidden"
            >
              <img :src="image.file_location" :alt="topic.title"/>
            </a>
          </div>
        </div>
      </div>

      <Reactions :topic-id="topic.id"/>

    </div>

    <div v-else class="text-center py-5">
      <div class="spinner-border text-secondary" role="status"></div>
    </div>
  </div>
</template>